<template>
  <!-- Halaman untuk menginput/upload file -->
  <div class="mainPage">
    <div class="mainModal">
      <form @submit.prevent="uploadFile">
        <input type="file" @change="handleFileChange($event)" />
        <button type="submit">Upload</button>
      </form>
    </div>

    <div class="pagination mt-2">
      <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1" @click.prevent="minPage"> &lt; </button>
      <button class="mr-1" id="pageButton" v-else disabled> &lt; </button>
      <p class="mr-1">{{ currentPage }}</p>
      <p class="mr-1">/</p>
      <p class="mr-1">{{ totalPage }} </p>
      <button type="button" id="pageButton" v-if="currentPage < totalPage" @click.prevent="addPage"> > </button>
      <button id="pageButton" v-else disabled> > </button>
    </div>
    <div class="tableRow">
      <div class="inRow">
        <lord-icon
          v-if="isLoading"
          src="https://cdn.lordicon.com/dpinvufc.json"
          trigger="loop"
          style="width:300px;height:300px"
        ></lord-icon>
      </div>
      <table v-if="!isLoading" class="table-bordered table-hover" id="tableData">
        <thead>
          <tr>
            <th>Tanggal</th>
            <th>Jam</th>
            <th>Jenis</th>
            <th>User</th>
            <th>Keterangan</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="e in dataTable" :key="e.id">
            <td>{{ formatDate(e.date) }}</td>
            <td>{{ e.detail }}</td>
            <td class="text-center">
              <button @click.prevent="downloadFile(e.detail)" title="Open picture">
                <img src="../assets/image.png" alt="" />
              </button>
              <!-- <button @click.prevent="showLocation(e)" title="View location">
                <img src="../assets/location.png" alt="" />
              </button> -->
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1" @click.prevent="minPage"> &lt; </button>
        <button class="mr-1" id="pageButton" v-else disabled> &lt; </button>
        <p class="mr-1">{{ currentPage }}</p>
        <p class="mr-1">/</p>
        <p class="mr-1">{{ totalPage }} </p>
        <button type="button" id="pageButton" v-if="currentPage < totalPage" @click.prevent="addPage"> > </button>
        <button id="pageButton" v-else disabled> > </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../API/axios';

export default {
  data() {
    return {
      selectedFile: null,
      dataTable: [],
      keyword: '',
      type: 0,
      endDate: '',
      startDate: '',
      currentPage: 1,
      perPage: 20,
      totalPage: 1,
      isLoading: false,
    };
  },
  created () {
    this.getDatatable();
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile, "file yang dipilih");
    },
    async uploadFile() {
      if (!this.selectedFile) {
        alert("Silakan pilih file terlebih dahulu!");
        return;
      }

      const formData = new FormData();
      formData.append('file', this.selectedFile); // Pastikan nama field sesuai dengan backend

      try {
        const response = await axios.post('/test', formData, {
          headers: {
            access_token: localStorage.getItem("access_token"),
            'Content-Type': 'multipart/form-data'
          }
        });
        alert('File berhasil diupload!');
        console.log(response.data);
      } catch (error) {
        alert('File gagal diupload!');
        console.error(error);
      }
    },

    async getDatatable() {
      try {
        let { data } = await axios({
          method: 'GET',
          url: '/test',
          params: {
            page: this.currentPage,
            limit: this.perPage,
            keyword: this.keyword,
            type: this.type,
            endDate: this.endDate,
            startDate: this.startDate,
          },
          headers: {
            access_token: localStorage.getItem('access_token'),
          },
        });
        this.dataTable = data.data2.result;
        let totalPage = Math.ceil(data.data2.dataLength / this.perPage);
        this.totalPage = totalPage;
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    formatDate(date) {
      let result = '';
      if (date) result = moment(date).format('DD-MM-YYYY');
      return result;
    },
    downloadFile(text) {
      // window.open(`https://dbsikuraja.otnielpangkung.com/${text}`);
            window.open(`http://localhost:3001/test/${text}`);
    },
    addPage() {
      this.currentPage = this.currentPage + 1;
      this.getDatatable()
    },
    minPage() {
      this.currentPage = this.currentPage - 1;
      this.getDatatable()
    },
  }
};
</script>

<style scoped>
.mainModal {
  padding: 20px;
  background-color: #f0f0f0;
  border-radius: 8px;
  width: 300px;
  margin: auto;
  text-align: center;
}

input[type="file"] {
  margin: 10px 0;
}

button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 4px;
}
</style>
